import MessageDrawerListFooter from './MessageDrawerListFooter';

export default MessageDrawerListFooter;
